import { useCallback, useEffect } from 'react';
import { ViewName } from '@tools/ui/enums';
import { FilterFindManyGenericTaskInput } from '@tools/ui/types/generated/graphql';
import BusyStore from '../../stores/busyStore';
import BusyTabAmount from '../components/busyTabAmount';

export const useUpdateTab = (
  view: ViewName,
  queryMap: Record<string, FilterFindManyGenericTaskInput>
) => {
  useEffect(() => {
    BusyStore.setView(view);
  }, [view]);

  const getTabAmount = useCallback(
    (tabName: string) => {
      const queryVerificationTasksArgs: FilterFindManyGenericTaskInput =
        queryMap[tabName];
      return (
        <BusyTabAmount
          queryVerificationTasksArgs={queryVerificationTasksArgs}
        />
      );
    },
    [queryMap]
  );

  return { getTabAmount };
};
